module.exports = __webpack_public_path__ + "static/img/split-img.8d73606.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/split-img.jpg
// module id = +4Db
// module chunks = 8